import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from 'vue-sweetalert2';
import VueQuillEditor from "vue-quill-editor";
import './assets/styles/tailwind.css';

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueQuillEditor /* { default global options } */);
Vue.use(require("vue-moment"));
Vue.use(VueSweetalert2);



import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
window.axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

// -------------------------------------------  public views -----------------------------------------------
Vue.component("menu-public", require("./components/MenuPublic.vue").default);
Vue.component("footer-page", require("./components/Footer.vue").default);

Vue.component("modal-page", require("./components/privateViews/Modal.vue").default);
Vue.component("create-user", require("./components/privateViews/CreateUser.vue").default);

Vue.component("bottom", require("./components/publicViews/Bottom.vue").default);
Vue.component("contact", require("./components/publicViews/Contact.vue").default);

Vue.component(
  "getStarted",
  require("./components/publicViews/GetStarted.vue").default
);
Vue.component(
  "contacts",
  require("./components/privateViews/contacts.vue").default
);
Vue.component(
  "contacts",
  require("./components/privateViews/contacts.vue").default
);
Vue.component(
  "send-invoice",
  require("./components/privateViews/CreateInvoice.vue").default
);

Vue.component(
  "pay-sub",
  require("./components/privateViews/PaySubcsription.vue").default
);

// -------------------------------------------  public views -----------------------------------------------
Vue.component(
  "subscriptions",
  require("./components/privateViews/Subscriptions.vue").default
);
Vue.component(
  "manage-blogs",
  require("./components/privateViews/Blog/ManageBlogs.vue").default
);


Vue.component(
  "products-index",
  require("./views/products/Index.vue").default
);

Vue.component(
  "team",
  require("./views/products/Team.vue").default
);

Vue.component(
  "new-footer",
  require("./views/products/Footer.vue").default
);

store.dispatch("getUser");
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
